module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dialCode"
    }
  }, [_vm._v(_vm._s(_vm.$t('dialCode')))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "add"
  }, [_vm._v("+")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.trim",
      value: (_vm.dialCode),
      expression: "dialCode",
      modifiers: {
        "number": true,
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'danger-border': _vm.inputBlur && _vm.codeHasError
    },
    attrs: {
      "type": "text",
      "name": "dialCode",
      "id": "dialCode",
      "placeholder": _vm.$t('dialCode')
    },
    domProps: {
      "value": (_vm.dialCode)
    },
    on: {
      "focus": function($event) {
        _vm.inputBlur = false
      },
      "blur": [function($event) {
        _vm.inputBlur = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dialCode = _vm._n($event.target.value.trim())
      }, _vm.dialCodeChange],
      "propertychange": _vm.dialCodeChange
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [(_vm.inputBlur && _vm.validateError) ? _c('span', [_vm._v(_vm._s(_vm.errors.first('dialCode')))]) : _vm._e(), _vm._v(" "), (_vm.inputBlur && !_vm.validateError && _vm.codeContentError) ? _c('span', [_vm._v(_vm._s(_vm.dialCodeErrorMsg))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c2def6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/callingCode/IndexMain.vue
// module id = 1291
// module chunks = 1